<script>
    import TheSvgIcon from "@main/packages/TheSvgIcon";

    export default {
        name: "LiteCompareControls",
        components: { TheSvgIcon },
        props: {
            max: Number,
            current: Number,
            size: Number,
        },
        methods: {
            handler(pos) {
                this.$emit("on-click", pos);
            },
        },
    };
</script>

<template>
    <div class="lite-compare-controls">
        <the-svg-icon
            class="lite-compare-controls__arrow is-prev"
            name="arrow"
            :size-w="size"
            @click.native="handler('prev')"
        >
        </the-svg-icon>

        <div class="lite-compare-controls__number">{{ current }}/{{ max }}</div>

        <the-svg-icon
            class="lite-compare-controls__arrow is-next"
            name="arrow"
            :size-w="size"
            @click.native="handler('next')"
        >
        </the-svg-icon>
    </div>
</template>

<style lang="scss">
    .lite-compare-controls {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .lite-compare-controls__arrow {
        fill: var(--primary--dark);
        cursor: pointer;
        &.is-next {
            transform: rotate(-180deg);
        }
    }

    .lite-compare-controls__number {
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        color: var(--secondary-text);
        margin: 0 20px;
    }
</style>
